import React from "react";

export const BrandLogo = (props) => {
  return (
    <svg
      width="500.000000pt"
      height="500.000000pt"
      viewBox="0 0 500.000000 500.000000"
      preserveAspectRatio="xMidYMid meet"
      fill="#3DDC97"
      {...props}
    >
      <g
        transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
        stroke="none"
      >
        <path
          d="M3170 3610 l0 -890 43 -26 c23 -15 61 -42 85 -61 l42 -34 0 950 0
   951 -85 0 -85 0 0 -890z"
        />
        <path
          d="M3469 3408 c0 -850 -3 -1089 -12 -1075 -181 280 -487 486 -806 543
   -103 18 -319 20 -416 4 -260 -44 -491 -166 -675 -356 -175 -181 -278 -378
   -327 -621 -23 -117 -22 -347 1 -458 124 -579 617 -985 1196 -985 611 0 1145
   474 1207 1070 4 41 7 726 5 1523 l-3 1447 -84 0 -85 0 -1 -1092z m-884 -1323
   l453 -332 -450 -354 c-248 -195 -457 -358 -465 -362 -11 -7 -13 109 -13 693 0
   492 3 699 11 695 5 -4 214 -157 464 -340z"
        />
      </g>
    </svg>
  );
};
